import { render, staticRenderFns } from "./node-summary.vue?vue&type=template&id=06b5e23a&scoped=true"
import script from "./node-summary.vue?vue&type=script&lang=ts"
export * from "./node-summary.vue?vue&type=script&lang=ts"
import style0 from "./node-summary.vue?vue&type=style&index=0&id=06b5e23a&prod&lang=scss&scoped=true"
import style1 from "./node-summary.vue?vue&type=style&index=1&id=06b5e23a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5e23a",
  null
  
)

export default component.exports